import React, { useEffect, useState } from 'react';
import api from '../services/api';

/**
 * نافذة منبثقة لوضع الصيانة.
 * تقرأ حالة الصيانة من /app-config (المسموح أثناء الصيانة)، وإن كانت مفعّلة
 * تعرض رسالة الصيانة فوق الموقع وتمنع الاستخدام حتى يُطفأ الوضع من لوحة الأدمن.
 */
const MaintenanceModal: React.FC = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('المنصة تحت الصيانة مؤقتاً، نعود قريباً إن شاء الله.');

  useEffect(() => {
    api
      .get('/app-config')
      .then((r) => {
        const sys = r.data?.data?.system;
        if (sys?.maintenance_mode) {
          setShow(true);
          if (sys.maintenance_message) setMessage(sys.maintenance_message);
        }
      })
      .catch(() => {});
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: 'rgba(10, 42, 38, 0.78)',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        fontFamily: "'Cairo', sans-serif",
        direction: 'rtl',
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 22,
          maxWidth: 440,
          width: '100%',
          padding: '40px 30px',
          textAlign: 'center',
          boxShadow: '0 24px 70px rgba(0, 0, 0, 0.35)',
        }}
      >
        <div
          style={{
            width: 76,
            height: 76,
            borderRadius: '50%',
            background: '#F1F7F5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 18px',
            fontSize: 38,
          }}
        >
          🛠️
        </div>
        <h1 style={{ color: '#005343', fontSize: 28, fontWeight: 800, margin: '0 0 4px' }}>الجلب</h1>
        <h2 style={{ color: '#0A2A26', fontSize: 18, fontWeight: 700, margin: '0 0 16px' }}>جارٍ الصيانة</h2>
        <p style={{ color: '#4B5563', fontSize: 15.5, lineHeight: 2, margin: '0 0 26px' }}>{message}</p>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: '#005343',
            color: '#fff',
            border: 'none',
            borderRadius: 12,
            padding: '12px 30px',
            fontSize: 15,
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          إعادة المحاولة
        </button>
      </div>
    </div>
  );
};

export default MaintenanceModal;
